import React from 'react';
import './caFeatures.css';
import {Container, Row, Col, CardImg} from 'reactstrap';
const CloudAcademyFeatures = () => {
    return(
        <div id='ca-features' className='py-5 my-5'>
            <Container>
                <Row className='px-2'>
                    {/* item 1 */}
                    <Col xs={{size: 12}} sm={{ size: 6}} lg={{size: 3}} className='py-5'>
                        <Row>
                            <Col xs={{ size: 5}} className='d-flex justify-content-center'>
                                <CardImg
                                 top
                                 src='img/aws-icon.svg'
                                 className='ca-icons'/>
                            </Col>
                            <Col xs={{size:7}} className='p-0'>
                                <h3>AWS Focused</h3>
                                <p>Our training goes in depth with AWS</p>
                            </Col>
                        </Row>
                    </Col>
                    {/* item 2 */}
                    <Col xs={{size: 12}} sm={{ size: 6}} lg={{size: 3}} className='py-5'>
                        <Row>
                            <Col xs={{ size: 5}} className='d-flex justify-content-center'>
                                <CardImg
                                 src='img/coming-soon-icon.svg'
                                 className='ca-icons'/>
                            </Col>
                            <Col xs={{size:7}} className='p-0'>
                                <h3>Coming Soon</h3>
                                <p>Microsoft Azure & Google Cloud</p>
                            </Col>
                        </Row>
                    </Col>
                    {/* item 3 */}
                    <Col xs={{size: 12}} sm={{ size: 6}} lg={{size: 3}} className='py-5'>
                        <Row>
                            <Col xs={{ size: 5}} className='d-flex justify-content-center'>
                                <CardImg
                                 src='img/portal-icon.svg'
                                 className='ca-icons'/>
                            </Col>
                            <Col xs={{size:7}} className='p-0'>
                                <h3>Online Portal</h3>
                                <p>Access your team progress daily</p>
                            </Col>
                        </Row>
                    </Col>
                    {/* item 4 */}
                    <Col xs={{size: 12}} sm={{ size: 6}} lg={{size: 3}} className='py-5'>
                        <Row>
                            <Col xs={{ size: 5}} className='d-flex justify-content-center '>
                                <CardImg
                                 src='img/sync-icon.svg'
                                 className='ca-icons'/>
                            </Col>
                            <Col xs={{size:7}} className='p-0'>
                                <h3>Certifications</h3>
                                <p>Providing credible training for the team</p>
                            </Col>
                        </Row>
                    </Col>
                    {/* item 5 */}
                    <Col xs={{size: 12}} sm={{ size: 6}} lg={{size: 3}} className='py-5'>
                        <Row>
                            <Col xs={{ size: 5}} className='d-flex justify-content-center'>
                                <CardImg
                                 src='img/assessment-icon.svg'
                                 className='ca-icons'/>
                            </Col>
                            <Col xs={{size:7}} className='p-0'>
                                <h3>Assessments</h3>
                                <p>Ensuring your team gets what is needed</p>
                            </Col>
                        </Row>
                    </Col>
                    {/* item 6 */}
                    <Col xs={{size: 12}} sm={{ size: 6}} lg={{size: 3}} className='py-5'>
                        <Row>
                            <Col xs={{ size: 5}} className='d-flex justify-content-center '>
                                <CardImg
                                 src='img/gear-icon.svg'
                                 className='ca-icons'/>
                            </Col>
                            <Col xs={{size:7}} className='p-0'>
                                <h3>Hands-On</h3>
                                <p>Apply knowledge in real ways</p>
                            </Col>
                        </Row>
                    </Col>
                    {/* item 7 */}
                    <Col xs={{size: 12}} sm={{ size: 6}} lg={{size: 3}} className='py-5'>
                        <Row>
                            <Col xs={{ size: 5}} className='d-flex justify-content-center '>
                                <CardImg
                                 src='img/group-icon.svg'
                                 className='ca-icons'/>
                            </Col>
                            <Col xs={{size:7}} className='p-0'>
                                <h3>Group Labs</h3>
                                <p>Creating a team approach for success</p>
                            </Col>
                        </Row>
                    </Col>
                    {/* item 8 */}
                    <Col xs={{size: 12}} sm={{ size: 6}} lg={{size: 3}} className='py-5'>
                        <Row>
                            <Col xs={{ size: 5}} className='d-flex justify-content-center '>
                                <CardImg
                                 src='img/star-icon.svg'
                                 className='ca-icons'/>
                            </Col>
                            <Col xs={{size:7}} className='p-0'>
                                <h3>Confidence</h3>
                                <p>Step out knowing your team is equipped</p>
                            </Col>
                        </Row>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}
export default CloudAcademyFeatures;